import ModelDetailView from './ModelDetailView';

export default ModelDetailView;
